import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../config/firebase';

interface Broker {
  id: string;
  address: string;
  email: string;
  name: string;
  phone: string;
  shortname: string;
}

interface BrokerState {
  items: Broker[];
  loading: boolean;
  error: string | null;
}

const initialState: BrokerState = {
  items: [],
  loading: false,
  error: null
};

// Fetch all brokers
export const fetchBrokers = createAsyncThunk(
  'brokers/fetchBrokers',
  async () => {
    try {
      const brokersRef = collection(db, 'brokers');
      const querySnapshot = await getDocs(brokersRef);
      return querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      })) as Broker[];
    } catch (error: any) {
      throw new Error(error.message || 'Failed to fetch brokers');
    }
  }
);

const brokerSlice = createSlice({
  name: 'brokers',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch Brokers
      .addCase(fetchBrokers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBrokers.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
        state.error = null;
      })
      .addCase(fetchBrokers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch brokers';
      });
  }
});

export default brokerSlice.reducer; 